import React from 'react';
import factory from 'components/Icons/factory';

export const Youtube = factory(
  'Youtube',
  <path d="M122.7 64s0 19.2-2.5 28.4c-1.3 5.1-5.3 9.1-10.4 10.5-9.1 2.5-45.8 2.5-45.8 2.5s-36.7 0-45.9-2.5c-5.1-1.3-9-5.3-10.4-10.5C5.3 83.2 5.3 64 5.3 64s0-19.2 2.5-28.4c1.3-5.1 5.3-9.1 10.4-10.5 9.1-2.5 45.8-2.5 45.8-2.5s36.7 0 45.9 2.5c5.1 1.3 9 5.3 10.4 10.5 2.4 9.2 2.4 28.4 2.4 28.4zM52 81.5L82.7 64 52 46.5v35z" />
);

export default Youtube;
